import { useTheme } from '@simplywallst/ui-core';
import TitleText from '../TitleText';
import { useState, useEffect } from 'react';
import { calcRectInfo } from './utils';

const TEXT_MAX_WIDTH = 96;
const TEXT_MAX_LENGTH = 16;

type Props = {
  // bgXCoord: number;
  // textXCoord: number;
  x: number;
  bgColor: string;
  textColor: string;
  textAnchor: 'start' | 'middle' | 'end';
  children: string;
  isTitleColor: boolean;
  isEdgeNode: boolean;
  groupX: number;
  isMobileScreen: boolean;
};

export const TitleColor = ({
  x,
  bgColor,
  textColor,
  textAnchor,
  children,
  isTitleColor,
  isEdgeNode,
  groupX,
  isMobileScreen,
}: Props) => {
  const [width, setWidth] = useState(0);
  const theme = useTheme();
  const y = (isEdgeNode && !isTitleColor) || isMobileScreen ? -26 : -32;
  const rectHeight = isMobileScreen ? 20 : 25;
  const rectY = isMobileScreen ? y - 13 : y - 17;
  const [content, setContent] = useState<string>(children);

  const { rectX, rectTransform, rectPadding } = calcRectInfo({
    x,
    groupX,
    width,
  });

  useEffect(() => {
    if (width > TEXT_MAX_WIDTH) {
      const truncatedContent = content.slice(0, TEXT_MAX_LENGTH) + '...';
      setContent(truncatedContent);
    }
  }, [content, width]);

  return (
    <>
      {isTitleColor && (
        <rect
          width={width + rectPadding}
          height={rectHeight}
          x={rectX}
          y={rectY}
          rx="6"
          fill={bgColor}
          transform={`translate(${rectTransform})`}
        />
      )}
      <TitleText
        x={x}
        y={y}
        fill={isTitleColor ? textColor : theme.color.paleWhite}
        onWidthUpdate={setWidth}
        textAnchor={textAnchor}
      >
        {content}
      </TitleText>
    </>
  );
};
